import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import {
  NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
  NOTICE_STORE_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/notice/store/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { BALANCE_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/noticeStoreConstants';

const NoticeStoreList = (props) => {
  const { noticeStoreList, getList, getExcelDownload, deleteNoticeStore } = props;
  const { list, filterOption, sortOption, pagination, summary } = noticeStoreList;

  return (
    <div className="notice-store-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
          sortOption: NOTICE_STORE_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={BALANCE_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            deleteNoticeStore,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default NoticeStoreList;
